import { type IThemedStyleSheet, type Theme, ThemedStyleSheet } from '../theme';

export type CodeBlockLineHighlighting = 'highlighted' | 'added' | 'deleted' | 'modified';

/**
 * Styles to highlight lines in code blocks.
 */
export const highlightingThemedStyles: {
    [key in CodeBlockLineHighlighting]: IThemedStyleSheet<{
        line: (theme: Theme) => Record<string, string>;
        text: (theme: Theme) => Record<string, string>;
    }>;
} = {
    added: ThemedStyleSheet.create({
        line: (theme) => ({
            backgroundColor: theme.colors.success.muted,
        }),
        text: (theme) => ({
            color: theme.colors.success.main,
        }),
    }),
    deleted: ThemedStyleSheet.create({
        line: (theme) => ({
            backgroundColor: theme.colors.danger.muted,
        }),
        text: (theme) => ({
            color: theme.colors.danger.main,
        }),
    }),
    modified: ThemedStyleSheet.create({
        line: (theme) => ({
            backgroundColor: theme.colors.warning.muted,
        }),
        text: (theme) => ({
            color: theme.colors.warning.main,
        }),
    }),
    highlighted: ThemedStyleSheet.create({
        line: (theme) => ({
            backgroundColor: theme.colors.background.standout,
        }),
        text: () => ({}),
    }),
};
